import { generateJsxKey } from '@utils/ast';
import { CardsComponent } from './component.cards.js';
import { jsx } from 'react/jsx-runtime';

const printCardsComponent = (node, context) => {
  return /*#__PURE__*/jsx(CardsComponent, {
    ...node
  }, generateJsxKey(context));
};
const cardsComponentJsxPrinters = {
  "cards-component": printCardsComponent
};

export { cardsComponentJsxPrinters, printCardsComponent };
//# sourceMappingURL=printer.to-jsx.js.map
